<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        app
        temporary
    >
      <v-list>
        <v-list-item>
          <img src="@/assets/image/logo.png" class="mobile-logo" alt="Налог сервис"/>
        </v-list-item>
      </v-list>

      <v-divider/>

      <v-list dense>
        <v-list-item
            v-for="([icon, text, link], i) in items"
            :key="i"
            link
            @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
                text
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="white" :flat="flat" class="px-15" :class="{ expand: flat }">
      <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          class="mr-4"
          v-if="isXs"
      />
      <div style="width: 100%;">
        <v-flex xs12 sm12 md12 lg8 offset-lg2 class="header-top">
          <table>
            <tr>
              <td class="logo">
                <img src="@/assets/image/logo.png" class="app-logo" alt="Налог сервис"/>
              </td>
              <td class="text">
                <a href="tel:+79208379193" style="text-decoration-line: none; color: #005096;">+7 (920) 837-91-93</a><br>
              </td>
              <td class="btn">
                <v-btn class="call-btn" small @click="$vuetify.goTo('#dialog')" dark>Заказать звонок</v-btn>
              </td>
              <td class="btn">
                <v-btn class="call-btn" small @click="$vuetify.goTo('#request')" dark>Заказать услугу</v-btn>
              </td>
            </tr>
          </table>
        </v-flex>
        <v-flex xs12 sm12 md12 lg8 offset-lg2 v-if="!isXs">
          <v-tabs centered grow class="header-menu" color="#005096">
            <v-tab
                v-for="([icon, text, link], i) in items"
                :key="i" @click="$vuetify.goTo(link)"
            >
              {{ text }}
            </v-tab>
          </v-tabs>
        </v-flex>
      </div>
    </v-app-bar>
  </div>
</template>


<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-star-outline", "Как заказать", "#order"],
      ["mdi-currency-rub", "Цены", "#pricing"],
      ["mdi-download-box-outline", "Ситуация", "#situation"],
      ["mdi-comment-text-outline", "Отзывы", "#comment"],
      ["mdi-contacts-outline", "Контакты", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
  },
};
</script>

<style lang="scss" scoped>

::v-deep .v-toolbar__content {
  height: 110px !important;
}

::v-deep .v-toolbar {
  height: 110px !important;
}

.mobile-logo {
  width: 220px;
}


.app-logo {
  margin-top: 8px;
  width: 220px;
}

.call-btn {
  background-color: #c42234 !important;
}

.header-top {
  margin-bottom: 0px;

  table {
    width: 100%;

    .logo {
      width: 50%;
      text-align: left;
    }

    .text {
      width: 30%;
      text-align: right;
      font-size: 22px;
    }

    .btn {
      text-align: left;
      padding-left: 10px;
    }
  }
}


@media (max-width: 1600px) {
  .header-top {
    table{
      .logo{
        width: 40%;
      }
      .text{
        width: 37%;
      }
    }
  }
}

@media (max-width: 1400px) {
  .header-top {
    table{
      .logo{
        width: 40%;
      }
      .text{
        width: 35%;
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 1290px) {
  .header-top {
    table{
      .logo{
        width: 40%;
      }
      .text{
        width: 32%;
      }
    }
  }
}

@media (max-width: 900px) {
  .header-top {
    table{
      .text{
        visibility: hidden;
      }
    }
  }
  .call-btn{
    visibility: hidden;
  }
}
</style>